export const BI_ERRORS = {
  tpa: {
    wix: {
      siteInfo: {
        get: {
          id: 1501,
          name: 'tpa.wix.siteInfo.get',
          error() {
            throw new Error(this.name);
          }
        }
      },
      activities: {
        getUserSessionToken: {
          id: 1501,
          name: 'tpa.wix.activities.getUserSessionToken',
          error() {
            throw new Error(this.name);
          }
        }
      },

    }
  },
  widget: {
    unhandled: {
      rejection: {
        id: 1501,
        name: 'widget.unhandled.rejection',
        error() {
          throw new Error(this.name);
        }
      }
    },
    statistic: {
      activity: {
        send: {
          id: 1501,
          name: 'widget.statistic.activity.send',
          error() {
            throw new Error(this.name);
          }
        }
      },
      counters: {
        emptyCtToken: {
          id: 1502,
          name: 'widget.statistic.counters.emptyCtToken',
          severity: 30,
          error() {
            throw new Error(this.name);
          }
        },
        send: {id: 1005, name: 'widget.statistic.counters.send'}
      }
    },
    content: {
      scripts: {
        wix: {
          id: 1502,
          name: 'widget.content.scripts.wix',
          error() {
            throw new Error(this.name);
          }
        },
        player: {
          id: 1503,
          name: 'widget.content.scripts.player',
          error() {
            throw new Error(this.name);
          }
        },
        coreJs: {
          id: 1503,
          name: 'widget.content.scripts.coreJs',
          error() {
            throw new Error(this.name);
          }
        }


      }
    },
    init: {
      initial: {
        id: 1504,
        name: 'widget.init.initial',
        error() {
          throw new Error(this.name);
        }
      },
      reinit: {
        id: 1505,
        name: 'widget.init.reinit',
        error() {
          throw new Error(this.name);
        }
      },
      statisticSubscribe: {
        id: 1506,
        name: 'widget.init.statisticSubscribe',
        error() {
          throw new Error(this.name);
        }
      }

    }
  }
};




// WEBPACK FOOTER //
// ./logging/errors.ts